'use es6';

import PropTypes from 'prop-types';
import { getColors } from 'reporting-ui-components/reports/utils/colors/chartColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ColumnChartIcon = ({
  colorSeriesType = 'DEFAULT',
  size = 25
}) => {
  const colors = getColors(colorSeriesType, [0, 1, 2, 3]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 80 80",
      children: [/*#__PURE__*/_jsx("rect", {
        fill: colors[0],
        x: "0",
        y: "0",
        height: "80",
        width: "14"
      }), /*#__PURE__*/_jsx("rect", {
        fill: colors[1],
        x: "20",
        y: "18",
        height: "62",
        width: "14"
      }), /*#__PURE__*/_jsx("rect", {
        fill: colors[2],
        x: "40",
        y: "31",
        height: "49",
        width: "14"
      }), /*#__PURE__*/_jsx("rect", {
        fill: colors[3],
        x: "60",
        y: "50",
        height: "30",
        width: "14"
      })]
    })
  });
};
ColumnChartIcon.propTypes = {
  size: PropTypes.number,
  colorSeriesType: PropTypes.string
};
export default ColumnChartIcon;